<template>
    <v-container class="mt-10">
        <v-row>
            <v-col cols="12" md="3">
                <v-switch v-model="filterByinvestor" label="Investor" @change="initializeDataBind"></v-switch>
            </v-col>
            <v-col cols="12" md="3">
                <v-switch v-model="filterByHasSalePrice" label="Includes Purchase Price" @change="initializeDataBind"></v-switch>
            </v-col>
            <v-col cols="12" md="3">
                <v-select v-model="filterByPropertyType" :items="['','SINGLE_FAMILY', 'MULTI_FAMILY', 'TOWN_HOUSE', 'CONDO', 'COMMERCIAL', 'OTHER']" label="Property Type" @change="initializeDataBind"></v-select>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="properties"
            :items-per-page="20"
            class="elevation-1"
        >
            <template #item.address="{ item }">
                <a href="#" @click.prevent="showAddressDetails(item)" class="address-link">
                    {{ item.Address.Street }}, {{ item.Address.City }}, {{ item.Address.State }}
                </a>
            </template>
            <template #item.UpdatedAt="{ item }">{{ formatTimestamp(item.UpdatedAt) }}</template>
        </v-data-table>
        <!-- Address Details Dialog -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title class="headline">Property Details</v-card-title>
                <v-card-text>
                    <v-simple-table dense>
                        <tbody v-if="selectedItem">                            
                            <tr v-if="selectedItem.PropertyID">
                                <td><strong>County Id:</strong></td>
                                <td>{{ selectedItem.PropertyID }}</td>
                            </tr>
                            <tr>
                                <td><strong>Address:</strong></td>
                                <td>{{ selectedItem.Address.Street }}, {{ selectedItem.Address.City }}, {{ selectedItem.Address.State }}</td>
                            </tr>
                            <tr v-if="selectedItem.BuyerName">
                                <td><strong>Buyer Name:</strong></td>
                                <td>{{ selectedItem.BuyerName }}</td>
                            </tr>
                            <tr v-if="selectedItem.BuyerAddress">
                                <td><strong>Buyer Street:</strong></td>
                                <td>{{ selectedItem.BuyerAddress.Street }}</td>
                            </tr>
                            <tr v-if="selectedItem.BuyerAddress">
                                <td><strong>Buyer City:</strong></td>
                                <td>{{ selectedItem.BuyerAddress.City }}</td>
                            </tr>
                            <tr v-if="selectedItem.BuyerAddress">
                                <td><strong>Buyer State:</strong></td>
                                <td>{{ selectedItem.BuyerAddress.State }}</td>
                            </tr>
                            <tr v-if="selectedItem.TaxableValue">
                                <td><strong>Assessed Value:</strong></td>
                                <td>${{ selectedItem.TaxableValue }}</td>
                            </tr>
                            <tr>
                                <td><strong>Property Type:</strong></td>
                                <td>{{ selectedItem.PropertyType }}</td>
                            </tr>
                            <tr>
                                <td><strong>Year Built:</strong></td>
                                <td>{{ selectedItem.YearBuilt }}</td>
                            </tr>
                            <tr v-if="selectedItem.HomeFacts">
                                <td><strong>Total Area:</strong></td>
                                <td>{{ selectedItem.HomeFacts.TotalArea }}</td>
                            </tr>
                            <tr v-if="selectedItem.HomeFacts">
                                <td><strong>Finished Area:</strong></td>
                                <td>{{ selectedItem.HomeFacts.FinishedArea }}</td>
                            </tr>
                            <tr v-if="selectedItem.HomeFacts">
                                <td><strong>Bedrooms:</strong></td>
                                <td>{{ selectedItem.HomeFacts.BedRooms }}</td>
                            </tr>
                            <tr v-if="selectedItem.HomeFacts">
                                <td><strong>Bathrooms:</strong></td>
                                <td>{{ selectedItem.HomeFacts.FullBaths }} / {{ selectedItem.HomeFacts.HalfBaths }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>    
</template>

<script>
    import { db } from '../firebase';
    import { collection, query, getDocs, where, orderBy, limit } from 'firebase/firestore';

    export default {
        name: "DataInsights",
        data: () => ({
            filterByHasSalePrice: null,
            filterByPropertyType: null,
            filterByinvestor: null,
            dialog: false,
            selectedItem: null,
            headers: [
                { text: 'Address', value: 'address' },
                { text: 'Price', value: 'Price' },
                { text: 'PropertyType', value: 'PropertyType' },
                { text: 'Year', value: 'YearBuilt' },
                { text: 'Investor?', value: 'Investor' },
                { text: 'Updated', value: 'UpdatedAt' }
            ],
            properties: []
        }),
        mounted() {
            this.initializeDataBind();
        },
        methods: {
            initializeDataBind: async function() {
                const dataCol = collection(db, 'county_property_details');                
                let filters = [];
                if (this.filterByinvestor) {
                    filters.push(where('Investor', '==', this.filterByinvestor))               
                }

                if (this.filterByHasSalePrice) {
                    filters.push(where("HasSalePrice", "==", this.filterByHasSalePrice));
                }
            
                if (this.filterByPropertyType) {
                    filters.push(where('PropertyType', '==', this.filterByPropertyType));
                }  

                const propQuery = query(dataCol, ...filters, orderBy('UpdatedAt', 'desc'), limit(300));
                let querySnapshot = await getDocs(propQuery);                          

                const data = querySnapshot.docs.map((doc) => doc.data());
                this.properties = data;
            
            },
            formatTimestamp: function(timestamp) {
                if (!timestamp) return '';

                const dateCST = new Date(timestamp);

                // Format date as MM-DD-YYYY and time as HH:MM:SS
                const month = (dateCST.getMonth() + 1).toString().padStart(2, '0');
                const day = dateCST.getDate().toString().padStart(2, '0');
                const year = dateCST.getFullYear();

                return `${month}/${day}/${year}`;
            },
            showAddressDetails: function(item) {
                this.selectedItem = item;
                this.dialog = true;
            }
        }        
    }
</script>

<style scoped>
</style>